import { scaleOrdinal } from 'd3-scale'
import Donut from './Donut'

function colorScale(stacked?: boolean) {
  return scaleOrdinal(stacked ? STACKED_COLORS : COLORS)
}

export default { Donut, colorScale }

export const COLORS = [
  '128dee',
  '10b4df',
  '94e1ff',
  '26e8d4',
  '24c7a3',
  '8938eb',
  '8e6cef',
  '9c46d0',
  'c758d0',
  'e01e84',
]
export const STACKED_COLORS = ['128dee', '10b4df', '94e1ff', 'd7dde1']
